import { Component } from '@angular/core';

@Component({
  selector: 'app-combo-markup-info',
  templateUrl: './combo-markup-info.component.html',
  styleUrl: './combo-markup-info.component.scss',
})
export class ComboMarkupInfoComponent {}
